import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import CompactToolCard from '../components/CompactToolCard';
import SEO from '../components/SEO';
import { imageToolsSchemas } from '../schemas';
import './ToolPage.css';

const ImageTools = () => {
  const popularTools = [
    { title: 'JPG → PNG', fromFormat: 'JPG', toFormat: 'PNG' },
    { title: 'PNG → JPG', fromFormat: 'PNG', toFormat: 'JPG' },
    { title: 'JPG → WebP', fromFormat: 'JPG', toFormat: 'WebP' },
    { title: 'PNG → WebP', fromFormat: 'PNG', toFormat: 'WebP' },
    { title: 'WebP → JPG', fromFormat: 'WebP', toFormat: 'JPG' },
    { title: 'WebP → PNG', fromFormat: 'WebP', toFormat: 'PNG' },
    { title: 'Reduce Image Size', fromFormat: 'JPG', toFormat: 'JPG', customLink: '/image-compressor' },
    { title: 'Image Cropper', fromFormat: 'IMG', toFormat: 'CROP', customLink: '/image-cropper' },
    { title: 'Image to Base64', fromFormat: 'IMG', toFormat: 'B64', customLink: '/base64-converter?tab=toBase64' },
    { title: 'Base64 to Image', fromFormat: 'B64', toFormat: 'IMG', customLink: '/base64-converter?tab=toImage' },
    { title: 'AVIF → WebP', fromFormat: 'AVIF', toFormat: 'WebP' },
    { title: 'PNG → AVIF', fromFormat: 'PNG', toFormat: 'AVIF' }
  ];

  return (
    <div className="tool-page">
      <SEO 
        title="Free Image Tools Online – Convert, Compress, Crop"
        description="Edit images instantly with free online image tools. Convert formats, compress size, crop photos & more — no watermark, no signup required."
        keywords="image tools online, free image editor, compress image online"
        path="/image-tools"
        schema={imageToolsSchemas}
      />
      <section className="section popular-section" style={{ paddingTop: '120px' }}>
        <div className="section-container">
          <div className="section-header">
            <motion.h2
              className="section-title"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              Explore Tools
            </motion.h2>
          </div>

          <div className="compact-tools-grid">
            {popularTools.map((tool, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.05 }}
              >
                <CompactToolCard {...tool} />
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ImageTools;
